import { render } from "./CreateLiftingRecord.vue?vue&type=template&id=85f2b756&scoped=true"
import script from "./CreateLiftingRecord.vue?vue&type=script&lang=js"
export * from "./CreateLiftingRecord.vue?vue&type=script&lang=js"

import "./CreateLiftingRecord.vue?vue&type=style&index=0&id=85f2b756&scoped=true&lang=css"
import "./CreateLiftingRecord.vue?vue&type=style&index=1&id=85f2b756&lang=css"
import "./CreateLiftingRecord.vue?vue&type=style&index=2&id=85f2b756&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=3&id=85f2b756&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f2b756"]])

export default __exports__